import React from 'react';
import { Bar } from 'react-chartjs-2';

// --- ここから追加・修正する部分 ---
// Chart.js v3/v4 で必要なコンポーネントをインポートします
import {
  Chart as ChartJS,
  CategoryScale, // X軸のカテゴリスケール
  LinearScale,   // Y軸のリニアスケール
  BarElement,    // バー要素
  Title,         // タイトル（今回は使用しないが、プラグインの一部として登録）
  Tooltip,       // ツールチップ
  Legend,        // 凡例
} from 'chart.js';

// インポートしたコンポーネントをChart.jsに登録します
// これが「Cannot read properties of undefined (reading 'defaults')」エラーを解決します
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
// --- ここまで追加・修正する部分 ---


const StackedBarChart = ({ labels, datasets }) => {
  const data = {
    labels: labels,
    datasets: datasets
  };

  // --- ここから options オブジェクトの修正 ---
  // Chart.js v3/v4 の記法に合わせて options を修正します
  const options = {
    responsive: true, // レスポンシブ対応を有効にする
    maintainAspectRatio: false, // アスペクト比を維持しない（コンテナのサイズに合わせる）
    scales: {
      // xAxes は x に、yAxes は y に変更
      x: {
        stacked: true,
        // 必要であれば軸のタイトルなどを追加できます
        // title: {
        //   display: true,
        //   text: '日付'
        // }
      },
      y: {
        stacked: true,
        // 必要であれば軸のタイトルなどを追加できます
        // title: {
        //   display: true,
        //   text: '値'
        // }
      }
    },
    plugins: { // tooltips は plugins.tooltip に変更
      tooltip: {
        enabled: true,
        mode: 'index',
        intersect: false, // ツールチップが重なる要素も表示
        // タイトルとボディのフォントサイズは、Chart.js v3/v4ではplugins.tooltip.bodyFont.sizeなどで設定します
        // ここではデフォルトのままにしておきますが、必要なら設定してください
        // titleFont: { size: 16 },
        // bodyFont: { size: 20 },
        callbacks: {
          label: function(tooltipItem) { // tooltipItem の構造もv2とv3/v4で少し異なります
            // データポイントの値を取得
            // tooltipItem.datasetIndex と tooltipItem.dataIndex を使用
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
            return '値: ' + value; // ツールチップ内に表示するテキスト
          }
        }
      },
      legend: { // 凡例の表示設定
        display: true,
        position: 'top', // 凡例の位置
      },
      title: { // グラフ全体のタイトル（今回はh6タグで表示しているので不要かもしれませんが、登録は必要です）
        display: false,
        text: 'グラフタイトル', // 必要であればここにタイトルを設定
      }
    },
  };
  // --- ここまで options オブジェクトの修正 ---

  return (
    <div className="chart-container">
      <Bar data={data} options={options}/>
    </div>
  );
};

export default StackedBarChart;
